import React from 'preact/compat';
import { useState, useEffect } from 'preact/hooks';

import Button from '@mui/material/Button';
import ArrowUpIcon from '@mui/icons-material/ArrowUpwardRounded';

import colors from '../colors';

const ScrollUpButton = () => {
    const [display, setDisplay] = useState(false);

    useEffect(() => {
        const onEvent = (event) => {
            const scrollTop = window.pageYOffset;
            const windowHeight = window.innerHeight;

            setDisplay(scrollTop > windowHeight);
        };

        window.addEventListener('scroll', onEvent);
        window.addEventListener('resize', onEvent);
    }, [setDisplay]);

    const handleClick = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
    };

    return (
    <Button
        onClick={handleClick}
        aria-label="Scroll to top"
        sx={{
            position: 'fixed',
            bottom: '20px',
            right: 'max(20px, calc(50% - 553px - 40px - 10px))',
            height: '40px',
            minWidth: '40px',
            backgroundColor: colors.action,
            display: 'block',
            padding: 0,
            zIndex: 100,
            opacity: display ? 1 : 0,
            transition: 'opacity 0.5s',
            '&:hover': {
                backgroundColor: colors.actionHover
            }
        }}
    >
        <ArrowUpIcon sx={{fontSize: '36px', color: colors.primaryText }} />
    </Button>
    );
};

export default ScrollUpButton;

